export const colorIcon = `
<svg fill="currentColor" viewBox="1 1 27 27">
  <g fill="none" fill-rule="evenodd">
    <path d="M4 0h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z"/>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19.317 14.584 8l4.585 11.317M12 16.5h5.592"/>
    <path style="color:var(--ex-color, currentColor)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 23.5h11.718"/>
  </g>
</svg>
`;
//# sourceMappingURL=icon.js.map